<template>
    <div class="page-content__content">
        <TendersFilter/>
		<div class="table-card">
			<TendersTable :table-data="getTendersList"/>
			<div class="pagination" v-if="getTendersPagination.total > getTendersPagination.limit">
				<vue-awesome-paginate
					:total-items="getTendersPagination.total"
					:items-per-page="getTendersPagination.limit"
					:max-pages-shown="3"
					v-model="curPage"
				/>
			</div>
		</div>
    </div>
	<PageLoader v-if="isLoading"/>
</template>

<script>
import TendersFilter from "@/components/sections/Tenders/TenderPage/TendersFilter.vue";
import TendersTable from "@/components/sections/Tenders/TenderPage/TendersTable.vue";
import PageLoader from "@/components/base/utils/PageLoader.vue";
import {mapActions, mapGetters} from "vuex";

export default {
    name: "TendersPage",
    components: {TendersTable, TendersFilter, PageLoader},
    async created() {
        await this.requestTendersList();
	},
    computed: {
        curPage: {
            get() {
                return Math.round(this.getTendersPagination.offset / this.getTendersPagination.limit) + 1
            },
            set(value) {
                this.updatePagination({offset: (value - 1) * this.getTendersPagination.limit})
            }
        },
        ...mapGetters({
			getTendersList: 'tenders/getTendersList',
            isLoading: 'isLoading',
			getTendersPagination: 'tenders/getTendersPagination'
        })
    },
    methods: {
        ...mapActions({
            requestTendersList: 'tenders/requestTendersList',
            updateFilterKey: 'tenders/updateFilterKey',
            updatePagination: 'tenders/updatePagination',
        })
    }
}

</script>


